import { setTerm } from './helpers';

export const setUpcomingSale = setTerm('is_upcoming_sale');
